<template>
  <div class="max-w-3xl mx-auto text-center pb-12">
    <h1 class="text-2xl font-bold">You're All Set!</h1>
    <p class="text-lg mb-12">
      Your account is ready to go! You can use the scheduling tool below to schedule your first call with a Humaniz
      specialist to get you onboarded and ready to go.
    </p>

    <div ref="calendlyEmbed" id="calendly-embed" style="min-width: 320px; height: 700px" class="mb-12"></div>

    <a href="/" class="btn btn-primary">Go to Dashboard</a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { confetti } from '@tsparticles/confetti';

export default {
  computed: {
    ...mapState(['currentUser']),
    companyTypes() {
      return ['Real Estate Team', 'Mortgage Team'];
    },
  },
  data() {
    return {
      loadedCalendly: false,
    };
  },
  mounted() {
    this.$store.dispatch('onboarding/completeOnboarding', { stripeCheckoutSessionId: this.$route.query.checkout_id });
    setTimeout(() => {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    }, 1000);

    if (!this.loadedCalendly && this.$refs.calendlyEmbed) {
      Calendly.initInlineWidget({
        url: 'https://calendly.com/d/yrm-3mh-zpw/humaniz-onboarding?hide_event_type_details=1&hide_gdpr_banner=1',
        parentElement: this.$refs.calendlyEmbed,
        prefill: {
          name: `${this.$store.state.onboarding.profile.firstName} ${this.$store.state.onboarding.profile.lastName}`,
          email: this.currentUser.email,
        },
      });
      this.loadedCalendly = true;
    }
  },
};
</script>
